import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  // Si el backend está arrancando en frío, la petición falla con error de red
  // claro en ~20s en lugar de quedarse colgada indefinidamente
  timeout: 20000,
});

export const setAuthToken = (token) => {
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const clearAuthToken = () => {
  delete api.defaults.headers.common.Authorization;
  localStorage.removeItem("reviewqr_token");
};

const savedToken = localStorage.getItem("reviewqr_token");
if (savedToken) setAuthToken(savedToken);

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const path = window.location.pathname;
    if (
      err.response?.status === 401 &&
      (path.startsWith("/admin") || path.startsWith("/superadmin"))
    ) {
      clearAuthToken();
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);

export const formatApiError = (e, fallback = "Ha ocurrido un error. Inténtalo de nuevo.") => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => x?.msg).filter(Boolean).join(" ");
  return fallback;
};

export const getRestaurant = async (slug) =>
  (await api.get(`/restaurants/${slug}`)).data;

export const submitFeedback = async (slug, { rating, feedback }) =>
  (await api.post(`/restaurants/${slug}/feedback`, {
    rating,
    feedback: feedback || null,
  })).data;

export const getFeedback = async (slug) =>
  (await api.get(`/restaurants/${slug}/feedback`)).data;

export const listRestaurants = async () => (await api.get(`/restaurants`)).data;

export const createRestaurant = async (payload) =>
  (await api.post(`/restaurants`, payload)).data;

export const updateRestaurant = async (slug, payload) =>
  (await api.put(`/restaurants/${slug}`, payload)).data;

export const deleteRestaurant = async (slug) =>
  (await api.delete(`/restaurants/${slug}`)).data;

export const uploadLogo = async (slug, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return (await api.post(`/restaurants/${slug}/logo`, formData)).data;
};

export const deleteLogo = async (slug) =>
  (await api.delete(`/restaurants/${slug}/logo`)).data;

export const changePassword = async (payload) =>
  (await api.post(`/auth/change-password`, payload)).data;

export const setNotificationEmail = async (slug, notification_email) =>
  (await api.patch(`/restaurants/${slug}/notification-email`, {
    notification_email,
  })).data;

export const listSupports = async () => (await api.get(`/nfc-supports`)).data;

export const createSupports = async (count = 1) =>
  (await api.post(`/nfc-supports`, { count })).data;

export const assignSupport = async (code, restaurant_slug) =>
  (await api.post(`/nfc-supports/${code}/assign`, { restaurant_slug })).data;

export const releaseSupport = async (code) =>
  (await api.post(`/nfc-supports/${code}/release`)).data;

export const disableSupport = async (code) =>
  (await api.post(`/nfc-supports/${code}/disable`)).data;
